import ActionTypes from "./ActionTypes"; 

const getCustomer = (payload) => {
  return {
    type: ActionTypes.GET_CUSTOMER,
    payload,
  };
}

const getDealership = (payload) => {
  return {
    type: ActionTypes.GET_DEALERSHIP,
    payload,
  };
}

export { getCustomer, getDealership };